import { Pipe, PipeTransform } from '@angular/core';
import { isNil, Nillable } from '@web/utils';

@Pipe({
  name: 'noData',
  standalone: true,
})
export class NoDataPipe implements PipeTransform {
  public transform<T>(value: Nillable<T>, text = '-'): T | string {
    if (isNil(value)) {
      return text;
    }

    return value;
  }
}
